import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import FailFlowWheel from '../Daily/FailFlowWheel';

/**
 * But its not actually a /coin shop wheel/...
 */
export default class CoinShopWheel extends Phaser.Group {
  constructor(config) {
    super(game);

    this.config = config;
    this.state = game.state.getCurrentState();

    // banner
    if (G.OMTsettings.global.jungleMatch) {
      this.blue_banner = G.makeImage(0, -295, 'purple_banner', 0.5, this);
      this.add(this.blue_banner);
    }

    const yOffset = G.OMTsettings.global.jungleMatch ? -297 : -280;

    this.titleTxt = new G.Text(0, yOffset, OMT.language.getText('Spin Wheel'), G.OMTsettings.global.window.mediumTitle.textStyle, 0.5, 350);
    this.add(this.titleTxt);

    this.moneyWheel = new FailFlowWheel({
      prizeList: {
        current: G.Utils.clone(this._getPrizeTable(!G.saveState.isFreeMoneySpinAvailable())),
        predeterminedPrize: -1,
      },
      premium: !G.saveState.isFreeMoneySpinAvailable(),
      isFirstTimeSpinning: false,
      autoStart: false,
    });
    this.moneyWheel.y = 5;
    this.moneyWheel.signals.collectWheelPrizeVisually.add(this.onWheelFinish, this);
    this.moneyWheel.fillWheel();
    this.add(this.moneyWheel);

    this.spinBtn = this.addSpinBtn(0, 255);

    this.dontApplyPrize = config.dontApplyPrize;
    this.coinTargetObject = config.coinTargetObject;
    this.onPrizeWon = new Phaser.Signal();
    this.onBoosterWon = new Phaser.Signal();
    this.onCoinsWon = new Phaser.Signal();
  }

  isDuringSpin() {
    return this.moneyWheel.spinState === this.moneyWheel.SpinStates.Spinning;
  }

  _getPrizeTable(gold) {
    if (!G.featureUnlock.multipleExtraMovesFailFlow) {
      if (G.IAP) {
        return G.json['configs/spinWheels'].failFlowGold;
      }
      // not IAP
      if (gold) {
        return G.json['configs/spinWheels'].failFlowGold;
      }
      return G.json['configs/spinWheels'].failFlowNormal;
    }

    // at this point, we know we want the extra moves wheels

    if (G.IAP) {
      return G.json['configs/spinWheels'].failFlowExtraMovesGold;
    }
    // not IAP
    if (gold) {
      return G.json['configs/spinWheels'].failFlowExtraMovesGold;
    }

    return G.json['configs/spinWheels'].failFlowExtraMovesNormal;
  }

  addSpinBtn(x, y) {
    const btn = new OMT_UI_SquareButton(x, y, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Spin'),
        textStyle: { style: 'font-white', fontSize: 50 },
      },
      options: {
        clickFunction: {
          onClick: this.onSpinBtnClicked.bind(this),
        },
      },
    });

    this.add(btn);

    return btn;
  }

  onSpinBtnClicked() {
    if (this.moneyWheel.spinState === this.moneyWheel.SpinStates.Spinning) { return; }
    if (this.isDuringSpin()) { return; }
    const freeSpin = G.saveState.isFreeMoneySpinAvailable();

    if (freeSpin) {
      if (this.config.failFlow) {
        OMT.platformTracking.logFTUEvent('FTUX_FirstFFWheelSpin', null);
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.WatchAdToSpinFailFlowWheel);
      }
      G.saveState.markLastMoneySpin();
      G.sb('onFreeMoneySpinUsed').dispatch();
    }

    this.spinBtn.visible = false;
    this.moneyWheel.startTheWheel();
  }

  onWheelFinish(prize) {
    const actualPrize = prize.current[prize.predeterminedPrize];
    const formattedPrize = [actualPrize.prize, actualPrize.amount];
    this.onPrizeWon.dispatch(formattedPrize);

    this.spinBtn.visible = true;
    this.spinBtn.scale.setTo(0);

    if (!this.dontApplyPrize) {
      this.applyPrize(prize, () => {
        game.add.tween(this.spinBtn.scale)
          .to({ x: 1, y: 1 }, 300, Phaser.Easing.Sinusoidal.In, true);
        this.moneyWheel.resetWheel();
      }, this);
    }
  }

  applyPrize(prize, callback, context) {
    const actualPrize = prize.current[prize.predeterminedPrize];
    const formattedPrize = [actualPrize.prize, actualPrize.amount];

    // DDNA Tracking
    const tGameArea = game.state.getCurrentState().key === 'Game' ? 'FAIL_FLOW' : 'MAP';
    const extraMovesBoosters = ['booster#5', 'booster#6', 'booster#10', 'booster#11'];
    let prizeIsExtraMoves = false;
    for (let i = 0; i < extraMovesBoosters.length; i++) {
      const booster = extraMovesBoosters[i];
      if (formattedPrize[0] === booster) {
        prizeIsExtraMoves = true;
        break;
      }
    }
    const tFailFlowExtraMoves = tGameArea === 'FAIL_FLOW' && prizeIsExtraMoves ? 1 : 0;
    const tLevelExtraMoves = tFailFlowExtraMoves === 1;
    console.log(formattedPrize);
    DDNA.transactionHelper.trackRewards(formattedPrize, [], {
      transactionType: 'REWARD',
      tActionType: 'WHEEL_SPIN',
      tGameArea,
      tFailFlowExtraMoves,
      tLevelExtraMoves,
    });

    // Transaction Tracking
    OMT.transactionTracking.logInventoryTransactionBegin();

    // Actual gift applying
    if (formattedPrize[0] === 'coin') {
      const labelIcon = this.moneyWheel.getLabelByPredeterminedPrize(prize.predeterminedPrize);
      if (this.coinTargetObject && this.state.uiTargetParticles && labelIcon) {
        const batch = this.state.uiTargetParticles.createCoinBatch(
          game.world.bounds.x + labelIcon.worldPosition.x,
          labelIcon.worldPosition.y,
          this.coinTargetObject,
          formattedPrize[1],
        );
        OMT.transactionTracking.addInventoryChange('coins', 0, formattedPrize[1]);
        if (callback) batch.onFinish.add(callback, context);
      } else {
        G.saveState.changeCoins(formattedPrize[1]);
        if (callback) callback.call(context);
      }
      // if we have more than one extra moves option on the wheel, dont increase the chances
      if (!G.featureUnlock.multipleExtraMovesFailFlow) {
        this.moneyWheel.modifyBoosterChance(20);
      }
      this.onCoinsWon.dispatch();
    } else {
      this.onBoosterWon.dispatch(formattedPrize[0]);

      const boosterNum = parseInt(formattedPrize[0].match(/\d+/)[0]);
      if (boosterNum && boosterNum !== 5 && boosterNum !== 6 && boosterNum !== 10 && boosterNum !== 11) { // don't track +3 and +5 moves boosters
        OMT.transactionTracking.addInventoryChange('boostersReceived', boosterNum, 1);
        OMT.transactionTracking.addInventoryChange('boostersUsed', boosterNum, 1);
      }
    }

    OMT.transactionTracking.logInventoryTransactionEnd();
  }
}
